<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'

// Formula para obtener las iteraciones tries = (tiempo_maximo * 60) / reloadTime
export default {
  name: 'WaitingStatus',
  props: {
    requestId: { type: [Number, String], default: null},
    reloadTime: { type: Number, default: 15 },
    url: { type: String, default: null },
    hasPostEvent: { type: Boolean, default: false }
  },
  data() {
    return {
      request_id: this.requestId,
      reloadTimeC: this.reloadTime,
      urlC: this.url,
      time: 0,
      waitingMD: true,
      callingMD: false,
      trytocheckMD: false,
      timeProgressBar: 0,
      hasposteventC: this.hasPostEvent,
      tries: 270,
      currentTry: 1,
    }
  },
  created() {
    this.intervalMD = setInterval(() => this.increment(), 1000)
  },
  destroyed() {
    clearInterval(this.intervalMD)
  },
  methods: {
    increment() {
      if (this.tries >= this.currentTry) {
        this.time = this.time + 1
        if (this.time === this.reloadTimeC) {
          this.waitingMD = false
          this.callingMD = true
          this.time = 0
          this.getData()
          this.currentTry = this.currentTry + 1
        }
        this.timeProgressBar = (this.time * 100) / this.reloadTimeC
      } else {
        this.waitingMD = false
        this.callingMD = false
        this.trytocheckMD = true
      }
    },
    getData() {
      axiosGetPost('get', this.urlC + this.request_id).then((response) => {
        let data = response.data
        if (data === true) {
          if (this.hasposteventC) {
            this.$emit('postevent')
          }
        } else {
          this.waitingMD = true
          this.callingMD = false
          this.trytocheckMD = false
        }
        return data
      })

    },
  },
}
</script>

<template>
  <div>
    <div class="row align-items-center justify-content-center" style="height: 250px">
      <div v-if="waitingMD === true" class="col-12 col-md-8 text-center">
        <b-spinner label="Waiting..." variant="secondary" class="ml-3"></b-spinner>
        <p><br><i>Waiting...</i></p>
        <p class="text-muted font-13 mb-4">
          <b-progress :value="timeProgressBar" :max="100" class="mb-3" variant="primary" height="2px"></b-progress>
        </p>
      </div>
      <div v-else-if="callingMD === true" class="col-12 col-md-8 text-center">
        <b-spinner label="Calling..." type="grow" variant="success" class="ml-3"></b-spinner>
        <p><br><i>Consulting...</i></p>
      </div>
      <div v-else-if="trytocheckMD === true" class="col-12 col-md-8 text-center">
        <b-spinner label="Try to check back later..." type="grow" variant="danger" class="ml-3"></b-spinner>
        <p><br><i>Try to check back later...</i></p>
      </div>
    </div>
  </div>
</template>